import { render, staticRenderFns } from "./VuePersianDatetimePickerWithWeek.vue?vue&type=template&id=3924d024&"
import script from "./VuePersianDatetimePickerWithWeek.vue?vue&type=script&lang=js&"
export * from "./VuePersianDatetimePickerWithWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports